import { ViewState } from 'app/pages/hosted-checkout/interface';
import { IPlan } from 'common/interface';
import { FC, PropsWithChildren, createContext, useState } from 'react';

export const CheckoutFrameContext = createContext<
  ViewState & { plan: IPlan | null; setPlan: (plan: IPlan | null) => void }
>({} as any);

export interface CheckoutFrameProviderProps {
  state: ViewState;
}

export const CheckoutFrameProvider: FC<PropsWithChildren<CheckoutFrameProviderProps>> = ({ children, state }) => {
  const [plan, setPlan] = useState<IPlan | null>(null);

  const contextValue = {
    ...state,
    plan,
    setPlan,
  };

  return <CheckoutFrameContext.Provider value={contextValue}>{children}</CheckoutFrameContext.Provider>;
};
